import { render, staticRenderFns } from "./PPF.vue?vue&type=template&id=29cff695&scoped=true&"
import script from "./PPF.vue?vue&type=script&lang=js&"
export * from "./PPF.vue?vue&type=script&lang=js&"
import style0 from "./PPF.vue?vue&type=style&index=0&id=29cff695&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cff695",
  null
  
)

export default component.exports